export const data = {
  "PROG_node-libinjection": {
    stargazers_count: 0,
    watchers_count: 0,
    forks_count: 0,
    description:
      "node.js wrapper for  libinjection C/C++ library  it's a simple and fast library to detect SQL Injection in a string.",
    full_name: "ntedgi/node-libinjection",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: [
      "cpp",
      "node-addon",
      "node-gyp",
      "nodejs",
      "security",
      "sql-injection-attacks",
      "sql-injection-filterer",
      "sql-injections",
    ],
    html_url: "https://github.com/ntedgi/node-libinjection",
  },
  "LANG_node-libinjection": {},
  PROG_SPI_slave_driver_implementation: {
    stargazers_count: 1,
    watchers_count: 1,
    forks_count: 0,
    description:
      "The project enables easy to implement realization of SPI slave for McSPI controller.",
    full_name: "ntedgi/SPI_slave_driver_implementation",
    license: {
      key: "gpl-2.0",
      name: "GNU General Public License v2.0",
      spdx_id: "GPL-2.0",
      url: "https://api.github.com/licenses/gpl-2.0",
      node_id: "MDc6TGljZW5zZTg=",
    },
    topics: [],
    html_url: "https://github.com/ntedgi/SPI_slave_driver_implementation",
  },
  LANG_SPI_slave_driver_implementation: {
    C: 90827,
    HTML: 26171,
    Makefile: 3769,
    Batchfile: 3505,
    "C++": 2957,
    Shell: 995,
    Python: 574,
  },

  "LANG_express-body-parser-error-handler": {
    JavaScript: 6508,
  },
  "PROG_nestjs-status-monitor": {
    stargazers_count: 2,
    watchers_count: 2,
    forks_count: 0,
    description:
      "Simple, self-hosted module based on Socket.io and Chart.js to report realtime server metrics for NestJS v9+ based servers.",
    full_name: "ntedgi/nestjs-status-monitor",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: [],
    html_url: "https://github.com/ntedgi/nestjs-status-monitor",
  },
  "PROG_node-efficientnet": {
    stargazers_count: 251,
    watchers_count: 251,
    forks_count: 36,
    description: "tensorflowJS implementation of EfficientNet 🚀",
    full_name: "ntedgi/node-efficientnet",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: [
      "classification",
      "deep-learning",
      "efficientnet",
      "efficientnet-model",
      "hacktoberfest",
      "image-classification",
      "image-recognition",
      "imagenet",
      "mobilenet",
      "pretrained-models",
      "tensorflow",
      "tfjs",
    ],
    html_url: "https://github.com/ntedgi/node-efficientnet",
  },
  "LANG_express-slow-down": {
    TypeScript: 39249,
    Shell: 61,
  },
  "PROG_data-stream-counter": {
    stargazers_count: 0,
    watchers_count: 0,
    forks_count: 0,
    description: "Distributed Frequency Count Algorithms for Data Streams",
    full_name: "ntedgi/data-stream-counter",
    license: null,
    topics: [
      "data-stream-processing",
      "distributed-lossy-counting",
      "distributed-sticky-sampling",
      "lossy-counting",
      "sticky-sampling",
    ],
    html_url: "https://github.com/ntedgi/data-stream-counter",
  },
  "LANG_kube-argocd-helm-workshop": {
    JavaScript: 11403,
    Shell: 451,
    Dockerfile: 121,
  },
  "PROG_NLP-HashTag-Parser": {
    stargazers_count: 9,
    watchers_count: 9,
    forks_count: 4,
    description: "split lower case  twitter hash tags by word entropy 🤯",
    full_name: "ntedgi/NLP-HashTag-Parser",
    license: {
      key: "gpl-3.0",
      name: "GNU General Public License v3.0",
      spdx_id: "GPL-3.0",
      url: "https://api.github.com/licenses/gpl-3.0",
      node_id: "MDc6TGljZW5zZTk=",
    },
    topics: [
      "bow",
      "hashtag",
      "hashtags-parser",
      "nlp",
      "text-analysis",
      "text-classification",
      "text-processing",
      "twitter",
      "twitter-api",
      "twitter-sentiment-analysis",
    ],
    html_url: "https://github.com/ntedgi/NLP-HashTag-Parser",
  },
  "LANG_cld3-kotlin": {
    Kotlin: 11085,
    "C++": 4212,
    C: 598,
  },
  "PROG_express-slow-down": {
    stargazers_count: 249,
    watchers_count: 249,
    forks_count: 15,
    description:
      "Slow down repeated requests; use as an alternative (or addition) to express-rate-limit",
    full_name: "express-rate-limit/express-slow-down",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: [
      "express",
      "express-middleware",
      "expressjs",
      "nodejs",
      "rate-limiter",
      "rate-limiting",
    ],
    html_url: "https://github.com/express-rate-limit/express-slow-down",
  },
  "LANG_universal-sentence-encoder": {
    Kotlin: 16249,
    Python: 843,
  },
  "PROG_cld3-kotlin": {
    stargazers_count: 20,
    watchers_count: 20,
    forks_count: 3,
    description:
      "Bindings to Google's Compact Language Detector 3 to JVM Based Languages",
    full_name: "ntedgi/cld3-kotlin",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: [
      "cld3",
      "kotlin",
      "langugage-recognition",
      "machine-learning",
      "nlp",
    ],
    html_url: "https://github.com/ntedgi/cld3-kotlin",
  },
  LANG_Crowlerito: {
    Kotlin: 7479,
    Shell: 71,
  },
  "PROG_mocha-parallel-tests": {
    stargazers_count: 0,
    watchers_count: 0,
    forks_count: 0,
    description:
      "Parallel test runner for mocha tests. Looking for maintainer.",
    full_name: "ntedgi/mocha-parallel-tests",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: [],
    html_url: "https://github.com/ntedgi/mocha-parallel-tests",
  },
  "LANG_nestjs-status-monitor": {
    TypeScript: 16199,
    JavaScript: 10540,
    HTML: 3724,
    CSS: 2386,
  },
  SOF_ME2: {
    badge_counts: {
      bronze: 52,
      silver: 25,
      gold: 3,
    },
    collectives: [
      {
        collective: {
          tags: [
            "firebase-ab-testing",
            "google-cloud-http-load-balancer",
            "stackdriver",
            "google-cloud-filestore",
            "google-cloud-marketplace",
            "nativescript-firebase",
            "google-container-optimized-os",
            "firebase-assistant",
            "google-cloud-instance-template",
            "firebase-app-indexing",
            "google-cloud-datalab",
            "google-cloud-storage",
            "dialogflow-es-fulfillment",
            "google-cloud-healthcare",
            "firebase-test-lab",
            "google-cloud-repository",
            "firebase-admob",
            "google-cloud-platform",
            "google-cloud-identity-aware-proxy",
            "google-cloud-firestore",
            "google-cloud-debugger",
            "google-cloud-cpp",
            "gcloud",
            "google-cloud-powershell",
            "google-cloud-instances",
            "google-app-engine",
            "google-app-engine-golang",
            "google-cloud-scheduler",
            "google-cloud-api-gateway",
            "google-analytics-firebase",
            "google-cloud-kms",
            "google-anthos",
            "google-cloud-bigtable",
            "google-cloud-iam",
            "google-cloud-launcher",
            "google-cloud-network-load-balancer",
            "firebase-dynamic-links",
            "redux-saga-firebase",
            "firebaseui",
            "maven-jib",
            "google-cloud-automl-nl",
            "firebase-queue",
            "firebase-tools",
            "cloud-document-ai",
            "google-cloud-internal-load-balancer",
            "google-cloud-shell",
            "firebase-console",
            "google-cloud-build",
            "firebase-app-check",
            "firebase-machine-learning",
            "google-cloud-interconnect",
            "google-cloud-load-balancer",
            "google-cloud-billing",
            "google-cloud-functions",
            "google-app-engine-deploy",
            "firebasesimplelogin",
            "google-app-engine-go",
            "google-cloud-trace",
            "firebase-predictions",
            "google-cloud-tpu",
            "google-translate",
            "cordova-plugin-firebasex",
            "google-compute-engine",
            "google-cloud-vertex-ai",
            "google-cloud-intellij",
            "google-app-engine-launch",
            "google-cloud-url-maps",
            "google-cloud-code",
            "google-app-engine-python",
            "google-container-os",
            "firebase-in-app-messaging",
            "google-dataflow",
            "google-cloud-save",
            "google-fusion-tables",
            "google-cloud-router",
            "google-cloud-identity",
            "firebase-extensions",
            "google-cloud-source-repos",
            "react-redux-firebase",
            "dialogflow-cx",
            "google-cloud-data-transfer",
            "google-app-engine-patch",
            "google-cloud-registry",
            "google-cloud-error-reporting",
            "google-cloud-console",
            "firebase",
            "google-cloud-php-client",
            "google-cloud-ml",
            "apigee-baas",
            "google-cloud-monitoring",
            "firebase-app-distribution",
            "google-cloud-profiler",
            "firebase-performance",
            "google-cloud-metrics",
            "google-cloud-python",
            "google-cloud-workstations",
            "google-cloud-ai",
            "google-cloud-print-privet",
            "google-cloud-armor",
            "google-cloud-translate",
            "google-bigquery",
            "firebase-remote-config",
            "google-cloud-dataflow",
            "firebase-storage",
            "google-cloud-search",
            "firebase-realtime-database",
            "google-prediction",
            "google-cloud-iot",
            "google-cloud-resource-manager",
            "google-cloud-data-fusion",
            "google-cloud-speech",
            "google-cloud-node",
            "dialogflow-es",
            "firebase-authentication",
            "google-cloud-stackdriver",
            "google-cloud-tasks",
            "google-cloud-spanner-emulator",
            "apigee",
            "google-cloud-endpoints-v2",
            "google-container-builder",
            "google-cloud-dlp",
            "jib",
            "google-cloud-robotics",
            "firebase-hosting",
            "google-cloud-dataproc",
            "google-cloud-recommendation",
            "google-cloud-transcoder",
            "google-cloud-messaging",
            "bigtable",
            "google-cloud-visualstudio",
            "google-cloud-vision",
            "google-cloud-print",
            "google-cloud-cdn",
            "google-cloud-run",
            "google-cloud-pubsublite",
            "google-cloud-logging",
            "looker-studio",
            "firebase-analytics",
            "google-cloud-sql",
            "google-cloud-ops-agent",
            "firebase-database",
            "rest-firebase",
            "google-cloud-talent-solution",
            "google-cloud-ml-engine",
            "google-cloud-storage-r",
            "google-kubernetes-engine",
            "firebase-mlkit",
            "firebase-polymer",
            "react-native-firebase",
            "google-cloud-dataproc-metastore",
            "google-cloud-vpn",
            "google-cloud-webrisk",
            "recaptcha-enterprise",
            "firebase-security",
            "google-cloud-tools",
            "google-cloud-dns",
            "google-cloud-networking",
            "vertex-ai-search",
            "looker",
            "google-cloud-deploy",
            "google-cloud-memorystore",
            "google-cloud-asset-inventory",
            "google-cloud-datastore",
            "google-cloud-pubsub",
            "firebase-notifications",
            "google-cloud-language",
            "google-cloud-spanner",
            "google-cloud-nl",
            "google-cloud-endpoints",
            "firebase-admin",
            "firebase-invites",
            "google-cloud-ai-platform-pipelines",
            "firebase-cli",
            "google-migrate-for-compute-engine",
            "google-cloud-automl",
            "google-cloud-dataprep",
            "google-cloud-shell-editor",
            "firebase-util",
            "google-cloud-composer",
            "google-cloud-sdk",
            "google-cloud-test-lab",
            "google-container-registry",
            "google-app-engine-php",
            "firebase-crash-reporting",
            "google-cloud-proxy",
            "firebase-cloud-messaging",
            "firebase-job-dispatcher",
          ],
          external_links: [
            {
              type: "support",
              link: "https://stackoverflow.com/contact?topic=15",
            },
          ],
          description:
            "A collective for developers who utilize Google Cloud’s infrastructure and platform capabilities. This collective is organized and managed by the Stack Overflow community.",
          link: "/collectives/google-cloud",
          name: "Google Cloud",
          slug: "google-cloud",
        },
        role: "member",
      },
    ],
    account_id: 5353609,
    is_employee: false,
    last_modified_date: 1683339000,
    last_access_date: 1714798329,
    reputation_change_year: 90,
    reputation_change_quarter: 0,
    reputation_change_month: 0,
    reputation_change_week: 0,
    reputation_change_day: 0,
    reputation: 5454,
    creation_date: 1416338197,
    user_type: "registered",
    user_id: 4267015,
    location: "Israel",
    website_url: "https://www.linkedin.com/in/naor-tedgi-11314284/",
    link: "https://stackoverflow.com/users/4267015/naor-tedgi",
    profile_image: "https://i.stack.imgur.com/q8N5O.jpg?s=256&g=1",
    display_name: "Naor Tedgi",
  },
  "PROG_kube-argocd-helm-workshop": {
    stargazers_count: 18,
    watchers_count: 18,
    forks_count: 2,
    description: "my workshop on GitOPS -> Helm -> ArgoCD ",
    full_name: "ntedgi/kube-argocd-helm-workshop",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: ["argocd", "docker", "helm", "helm-chart", "k8s", "kubernetes"],
    html_url: "https://github.com/ntedgi/kube-argocd-helm-workshop",
  },
  "LANG_node-efficientnet": {
    TypeScript: 29598,
    JavaScript: 24578,
    HTML: 3352,
    SCSS: 1774,
    Shell: 1296,
    Python: 609,
    Dockerfile: 458,
  },
  "LANG_NLP-HashTag-Parser": {
    JavaScript: 16079,
    HTML: 1892,
    CSS: 459,
    SCSS: 132,
  },
  "LANG_albert-fine-tuning-squad-2.0": {
    Python: 2716,
    Shell: 160,
  },
  PROG_Crowlerito: {
    stargazers_count: 5,
    watchers_count: 5,
    forks_count: 0,
    description:
      "Crowl Twitter Advanced Search  , Basically Just get all posts ever created by an account  💣",
    full_name: "ntedgi/Crowlerito",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: ["crawler", "kotlin", "maven", "twitter", "twitter4j"],
    html_url: "https://github.com/ntedgi/Crowlerito",
  },
  "LANG_mocha-parallel-tests": {
    JavaScript: 58297,
    TypeScript: 48279,
    Shell: 15338,
  },
  "ab.storage.messagingSessionStart.a9882122-ac6c-486a-bc3b-fab39ef624c5": {
    v: 1683127384181,
  },
  "LANG_infra-meetings": {
    HTML: 30329,
    JavaScript: 23850,
    C: 335,
  },
  PROG_node: {
    stargazers_count: 103983,
    watchers_count: 103983,
    forks_count: 27943,
    description: "Node.js JavaScript runtime ✨🐢🚀✨",
    full_name: "nodejs/node",
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    topics: [
      "javascript",
      "js",
      "linux",
      "macos",
      "mit",
      "node",
      "nodejs",
      "runtime",
      "windows",
    ],
    html_url: "https://github.com/nodejs/node",
  },
  "PROG_express-body-parser-error-handler": {
    stargazers_count: 16,
    watchers_count: 16,
    forks_count: 2,
    description:
      "middleware to be set right after body parser in order to return 4xx error back to the client",
    full_name: "ntedgi/express-body-parser-error-handler",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: [],
    html_url: "https://github.com/ntedgi/express-body-parser-error-handler",
  },
  "PROG_albert-fine-tuning-squad-2.0": {
    stargazers_count: 4,
    watchers_count: 4,
    forks_count: 0,
    description:
      "Fine-tuning a Transformer albert model for Question Answering on Squad 2.0",
    full_name: "ntedgi/albert-fine-tuning-squad-2.0",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: ["albert", "machine-learning", "nlp", "transformer"],
    html_url: "https://github.com/ntedgi/albert-fine-tuning-squad-2.0",
  },
  LANG_node: {
    JavaScript: 14718158,
    "C++": 5128070,
    Python: 2569066,
    C: 640244,
    HTML: 163390,
    Shell: 101101,
    Makefile: 54400,
    Batchfile: 41376,
    "Emacs Lisp": 14363,
    Perl: 11715,
    R: 8037,
    TypeScript: 702,
    Assembly: 157,
  },
  "PROG_infra-meetings": {
    stargazers_count: 3,
    watchers_count: 3,
    forks_count: 0,
    description: "Demand-TechTalks",
    full_name: "ntedgi/infra-meetings",
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    topics: [],
    html_url: "https://github.com/ntedgi/infra-meetings",
  },
  "LANG_data-stream-counter": {
    Kotlin: 9460,
  },
  "PROG_universal-sentence-encoder": {
    stargazers_count: 0,
    watchers_count: 0,
    forks_count: 0,
    description: "Universal Sentence Encoder on JVM - Kotlin",
    full_name: "ntedgi/universal-sentence-encoder",
    license: null,
    topics: [],
    html_url: "https://github.com/ntedgi/universal-sentence-encoder",
  },
};
